import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Link,
	ListItem,
	Text,
	UnorderedList,
} from "@chakra-ui/react";
import React from "react";
import { FaLinkedin } from "react-icons/fa";

const FundInFocusArthaVenture: React.FC = () => (
	<>
		{/* members */}
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "450px", sm: "300px" }}
			minH={{ xs: "450px", sm: "300px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir="column"
				px={{ xs: "20px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Heading
					as="h1"
					mb="20px"
					variant="reportCardTitle"
					fontSize={{ xs: "26px", sm: "28px", md: "32px", lg: "38px" }}
					color="white"
					lineHeight={{ xs: "34px", md: "39px", lg: "42px" }}
				>
					Fund In Focus: Artha Venture Fund on Finding Purpose, Sustainability,
					and Scalability in Startups
				</Heading>
				<Text
					fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
					fontWeight="600"
					color="white"
					lineHeight="21px"
				>
					Anirudh A Damani, Managing Partner,
					<Link href="https://artha.vc/" target="_blank" rel="noreferrer">
						Artha Venture Fund
					</Link>
				</Text>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box as="main" w="100%" pb="40px">
				<Text variant="blogAnswer">
					Welcome to our ‘Fund in Focus’ series where we profile our member
					funds, underscore their investment philosophy, and highlight some of
					their interesting work. Today we speak to Anirudh A Damani of Artha
					Venture Fund who offers insights into their investment philosophy,
					which centres on six principles, including solving real human
					problems, founder potential, and market scalability. Emphasizing
					adaptability, Artha has evolved its approach to meet India’s growing
					startup ecosystem, with recent investments in companies like Agnikul
					Cosmos and Futwork reflecting this commitment. Artha shares optimism
					for sectors such as FinTech infrastructure, the affluent Indian
					market, deep tech, and B2B SaaS. Embracing India’s unique market
					dynamics, Artha remains committed to nurturing sustainable,
					high-impact ventures tailored for long-term success.
				</Text>
			</Box>

			<Img
				src="https://static.levocdn.com/WGLBUT82/AnirudhADamani-Director-ArthaIndiaVentures-5AQCZxXJxf9j.JPG"
				alt="Anirudh A Damani"
				boxSize="300px"
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "70px" }}
				mb="20px"
				objectFit="contain"
			/>
			<Box>
				<Flex flexDir={{ xs: "column", lg: "row" }} rowGap="16px">
					<Heading
						textAlign={{ xs: "center", md: "left" }}
						fontWeight="800"
						color="blue.400"
					>
						Spokesperson: Anirudh A Damani, Partner,
						<Link href="https://artha.vc/" target="_blank" rel="noreferrer">
							Artha Venture Fund
						</Link>
					</Heading>
					<Flex
						columnGap={{ xs: "4px", md: "16px" }}
						justifyContent={{ xs: "center", md: "flex-start" }}
						transform={{ xs: "translateX(12px)", md: "none" }}
					>
						<Box alignSelf="start" mt="5px">
							<Link
								href="https://www.linkedin.com/in/showmedamani/"
								target="_blank"
							>
								<IconButton
									aria-label="linkedin"
									icon={
										<FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
									}
									variant="unstyled"
									cursor="pointer"
								/>
							</Link>
						</Box>
					</Flex>
				</Flex>
				<Box
					ml={{ xs: "auto", md: "345px", lg: "370px" }}
					mr={{ xs: "auto", md: "0px" }}
					width={{ xs: "160px", md: "80px" }}
					h="2px"
					bgColor="primary.500"
					borderRadius="5px"
					mt={{ xs: "16px", md: "10px" }}
					mb="15px"
				/>
				<Box>
					<Heading variant="blogQuestion" pb="20px" pt="16px" pl="-20px">
						1. Can you share Artha Venture Fund’s core investment philosophy?
						What key values guide your decision-making process when selecting
						startups to back?
					</Heading>
					<Text variant="blogAnswer" pb="20px">
						At Artha Venture Fund, our core investment philosophy is anchored in
						six fundamental principles that guide our decision-making process
						when selecting startups to back:
						<br />
						<br />
						<UnorderedList>
							<ListItem>
								<Text as="span" variant="blogAnswer" py="16px">
									<span style={{ fontWeight: "bold" }}>
										Solving Real Human Problems:
									</span>
									We invest in startups that address genuine human needs. We
									believe meaningful ventures provide tangible solutions to
									real-world challenges, creating lasting value for society.
								</Text>
							</ListItem>
							<ListItem>
								<Text as="span" variant="blogAnswer" py="16px">
									<span style={{ fontWeight: "bold" }}>
										Founder’s Right to Win:
									</span>
									We look for founders who are uniquely positioned to solve the
									problems they’re tackling. This means they possess the right
									mix of experience, expertise, and passion, giving them a
									competitive edge and a higher likelihood of success.
								</Text>
							</ListItem>
							<ListItem>
								<Text as="span" variant="blogAnswer" py="16px">
									<span style={{ fontWeight: "bold" }}>
										Positive Unit Economics:
									</span>
									Financial sustainability is crucial. We seek ventures
									demonstrating positive unit economics because no financial
									model transforms a gross loss into a net profit. Sound
									economics are essential for long-term viability.
								</Text>
							</ListItem>
							<ListItem>
								<Text as="span" variant="blogAnswer" py="16px">
									<span style={{ fontWeight: "bold" }}>
										Massive Market Potential:
									</span>
									Startups must address large markets with significant growth
									potential. Scalability is key, so we look for ventures that
									can expand rapidly and capture substantial market share.
								</Text>
							</ListItem>
							<ListItem>
								<Text as="span" variant="blogAnswer" py="16px">
									<span style={{ fontWeight: "bold" }}>
										Pathway to Market Leadership with a Strong Moat:
									</span>
									We prefer companies with a clear strategy to become the number
									one or two players in their category. Additionally, they
									should have a strong moat—unique advantages that protect them
									from competitors and sustain their market position over time.
								</Text>
							</ListItem>
							<ListItem>
								<Text as="span" variant="blogAnswer" py="16px">
									<span style={{ fontWeight: "bold" }}>
										Tech-Enabled, Not Tech-First:
									</span>
									In the Indian context, businesses thrive when they are
									tech-enabled rather than tech-first. A robust business model
									enhanced by technology often outperforms models prioritising
									technology before establishing a solid business foundation.
								</Text>
							</ListItem>
						</UnorderedList>
						<br />
						<Text as="span" variant="blogAnswer" py="16px">
							These six principles guide us in evaluating ventures and forming
							partnerships with founders. When presenting to us, we expect
							entrepreneurs to articulate clearly how their startups align with
							these principles. This approach ensures we back companies that are
							innovative and built on sustainable business models poised for
							long-term success.
						</Text>
					</Text>
				</Box>
				{/* Question 2 */}
				<Box pt="20px">
					<Heading variant="blogQuestion" pb="20px" pt="30px">
						2. How has your investment strategy evolved over the years,
						particularly with respect to India&apos;s growing startup ecosystem?
					</Heading>
					<Box>
						<Text variant="blogAnswer" pb="16px">
							When we launched our first fund, our investment philosophy was
							built around four core principles: solving a real human problem,
							ensuring positive unit economics, targeting massive scale
							potential, and investing in tech-enabled companies with a strong
							moat. These foundations served us well initially, but as we gained
							more experience and the Indian startup ecosystem evolved, we
							recognized the need to adapt our strategy.
							<br /> <br />
							We added two more crucial principles: the founder’s right to win
							and a clear pathway to market leadership. In India’s competitive
							and rapidly changing market, customer memory is short—they often
							remember only the top two players in any category. Therefore, it’s
							essential for the startups, we back, to aim for market leadership
							and establish a robust moat that sustains their position.
							<br /> <br />
							The concept of the founder’s right to win became vital as we
							observed that steering a venture to success in India requires an
							experienced and capable leader. It takes someone with a deep
							understanding of the market and the resilience to navigate its
							complexities, especially given the challenges and opportunities
							that emerged between 2020 and 2024 during the COVID-19 years.
							<br /> <br />
							This evolution in our investment strategy reflects our commitment
							to continuously learning and adapting. By incorporating these
							additional principles, we’ve strengthened our ability to identify
							and support startups that are not only innovative but also
							positioned for sustainable success in India’s dynamic startup
							landscape.
						</Text>
					</Box>
				</Box>

				{/* Question 3 */}
				<Box pt="20px">
					<Heading variant="blogQuestion" pb="20px" pt="30px">
						3. What are some of the recent investments made by Artha Venture
						Fund that you’re particularly excited about? What factors attracted
						you to these companies?
					</Heading>
					<Box>
						<Text variant="blogAnswer" pb="16px">
							We’re incredibly excited about several investments that embody our
							vision for transformative impact. Although not a recent addition
							to our portfolio, Agnikul Cosmos has achieved remarkable
							milestones in the past six months. Their advancements have
							captured global attention and ignited a renewed passion for space
							exploration in India. Agnikul’s work opens up vast opportunities
							for Indian space tech companies aspiring to reach new heights, and
							being part of their journey is truly exhilarating.
							<br /> <br />
							More recently, our investment in Futwork has been a source of
							great enthusiasm. The team at Futwork is building something
							uniquely impactful, and we’re proud to have partnered with the
							Michael & Susan Dell Foundation (MSDF) in this venture. Their
							innovative approach to solving real-world problems aligns
							perfectly with our investment philosophy and commitment to backing
							founders with a solid right to win.
							<br /> <br />
							We’re also thrilled about our follow-on investments in companies
							like GetWork. They have implemented LLMs to revolutionize how
							entry-level candidates are evaluated in the recruiting process. By
							leveraging AI and LLMs, GetWork makes it easier for deserving
							candidates to be discovered, streamlining the recruitment process
							for employers. They also provide constructive feedback to
							candidates who aren’t selected, guiding them on how to upskill for
							future opportunities.
							<br /> <br />
							Another venture that excites us is InstaAstro, which organizes the
							highly fragmented astrologer space through innovative online
							solutions. They’re tapping into a massive market with significant
							potential, and their tech-enabled platform exemplifies how
							traditional industries can be transformed through technology.
							<br /> <br />
							What attracts us to these companies is their ability to address
							large markets with billions of dollars in potential while solving
							genuine human problems. They embody the principles that get me and
							my team out of bed every morning—ventures with strong business
							models, positive unit economics, and the potential to make us
							proud for years to come. Supporting founders who are passionate,
							capable, and uniquely positioned to lead their industries is at
							the heart of what we do at Artha Venture Fund.
						</Text>
					</Box>
				</Box>
				{/* Question 4 */}
				<Box pt="20px">
					<Heading variant="blogQuestion" pb="20px" pt="30px">
						4. Which sectors or industries do you see as the most promising in
						the near future for venture capital investment, particularly in the
						Indian context?
					</Heading>
					<Box>
						<Text variant="blogAnswer" pb="16px">
							As we develop the thesis for our upcoming early-stage funds, we’re
							increasingly excited about thematic investing rather than focusing
							solely on specific sectors or industries. There are four key
							themes that we believe hold significant promise in India’s venture
							capital landscape:
							<br /> <br />
							<UnorderedList>
								<ListItem>
									<Text as="span" variant="blogAnswer" py="16px">
										<span style={{ fontWeight: "bold" }}>
											FinTech Infrastructure:
										</span>{" "}
										India is a credit-hungry market with immense untapped
										potential in financial services. Despite having over a
										billion debit cards in circulation, only about 100 million
										credit cards are active. We see a vast opportunity in
										building a fintech infrastructure that expands credit access
										and meets the financial needs of a large, underserved
										population.
									</Text>
								</ListItem>
								<ListItem>
									<Text as="span" variant="blogAnswer" py="16px">
										<span style={{ fontWeight: "bold" }}>
											The Affluent Indian Market (Urban Premium):
										</span>{" "}
										We’re focusing on the top 6–8% of India’s consumer market.
										By 2030, this segment is expected to encompass over 125
										million people with an annual income of 10 lakh rupees or
										more. Addressing the needs of this affluent segment presents
										an exciting opportunity due to substantial margins and scale
										potential.
									</Text>
								</ListItem>
								<ListItem>
									<Text as="span" variant="blogAnswer" py="16px">
										<span style={{ fontWeight: "bold" }}>
											Deep Tech with a Focus on Space Technology:
										</span>{" "}
										The deep tech sector, particularly space tech, is another
										area that excites us. The push towards privatization in the
										space sector opens new avenues for innovation and
										investment.
									</Text>
								</ListItem>
								<ListItem>
									<Text as="span" variant="blogAnswer" py="16px">
										<span style={{ fontWeight: "bold" }}>
											B2B SaaS—‘Build in India, Sell to the World’:
										</span>{" "}
										We continue to be enthusiastic about B2B SaaS companies that
										develop solutions in India for global markets. This theme
										has been part of our portfolio since 2012, with successful
										investments in companies like Exotel, Clientell, Lemnisk,
										and others showcasing massive-scale potential. Indian
										startups ability to create world-class SaaS products
										positions them well to capture global market share,
										leveraging cost advantages and a strong talent pool.
										<br />
										These four themes represent areas where we see significant
										growth potential and opportunities to back innovative
										startups. By concentrating on these themes, we’re not only
										aligning with current market trends but also anticipating
										the future needs of both domestic and international markets.
										We’re excited to continue supporting ventures in these
										domains as we build our next 10-year fund, confident that
										they will drive substantial value and innovation in the
										years to come.
									</Text>
								</ListItem>
							</UnorderedList>
						</Text>
					</Box>
				</Box>
				{/* Question 5 */}
				<Box pt="20px">
					<Heading variant="blogQuestion" pb="20px" pt="30px">
						5. How do you identify and evaluate emerging trends that could lead
						to future investment opportunities?
					</Heading>
					<Box>
						<Text variant="blogAnswer" pb="16px">
							Identifying and evaluating emerging trends is a multifaceted
							process at Artha Venture Fund, rooted in deep engagement with our
							portfolio and leveraging our extensive network. Being closely
							involved with our 125 investments allows us to observe common
							challenges and opportunities that arise across different sectors.
							By actively listening to our founders and engaging in open
							dialogues, we gain valuable insights into the issues they face,
							which often signal broader market trends.
							<br /> <br />
							Our unique position as a family office-backed fund grants us
							access to a wide array of family offices both in India and
							globally. This network enables us to interact with industry
							leaders, understand diverse perspectives, and stay attuned to
							global developments. Traveling internationally and engaging with
							stakeholders worldwide allows us to see how different markets
							evolve and how industry players perceive future opportunities.
							<br /> <br />
							Additionally, our family’s significant presence in the stock
							market broadens our worldview. This exposure complements our
							venture capital activities by providing insights into economic
							indicators and market sentiments that influence both public and
							private markets.
							<br /> <br />
							By combining these experiences—deep portfolio involvement, global
							networking, and a comprehensive market perspective—we can
							anticipate the undercurrents of emerging trends. This holistic
							approach helps us “crystal gaze” into the future, enabling us to
							develop investment theses and thematic focuses that align with
							upcoming opportunities. It’s about recognizing the signals today
							that will define tomorrow&apos;s markets and positioning ourselves
							to support ventures poised to lead in those spaces.
						</Text>
					</Box>
				</Box>
				{/*  */}
				<Box pt="20px">
					<Heading variant="blogQuestion" pb="20px" pt="30px">
						6. What role does India’s growing entrepreneurial landscape play in
						your portfolio strategy? How do you see India’s position as a global
						investment destination evolving?
					</Heading>
					<Box>
						<Text variant="blogAnswer" pb="16px">
							India’s entrepreneurial landscape is central to our portfolio
							strategy at Artha Venture Fund. My father often said that India’s
							uniqueness lies in its vast size—a boon that offers unparalleled
							opportunities. This demographic dividend positions us
							advantageously on the global stage. I firmly believe that our
							entrepreneurial talent will propel India to reclaim its status as
							the
							<span style={{ fontWeight: "bold" }}>Sone Ki Chidiya</span>
							(Golden Bird), symbolizing prosperity and abundance.
							<br /> <br />
							Addressing even a small problem can have a massive impact in a
							country like India. Solving an issue affecting just 1% of the
							population translates to reaching about 15 million
							people—exceeding the population of many nations. Achieving 10%
							market penetration means serving a market that is the size of
							several countries combined. This sheer scale provides startups
							with incredible opportunities for growth and scalability.
							<br /> <br />
							India is fundamentally a consumption-driven economy, relying more
							on internal demand than external influences. With initiatives like
							“Make in India” and a robust services sector, we’re evolving into
							not just one of the largest consumer markets but also a
							significant producer of goods and services. Unlike some of our
							neighbors who heavily rely on exports, India’s consumption and
							production occur within the same economy, yet we also have access
							to global markets. This unique dynamic enhances our attractiveness
							as an investment destination.
							<br /> <br />
							Looking ahead, I see the next two to three decades as belonging to
							India. Our vast market potential and growing entrepreneurial
							talent pool position us as a leading global economic force.
							However, it’s imperative that we, as Indians, seize this
							opportunity responsibly. The only obstacles to realizing this
							potential are those we might create ourselves. By fostering
							innovation, supporting startups, and maintaining a conducive
							business environment, we can ensure that India fulfills its
							promise and continues to evolve as a premier global investment
							destination.
						</Text>
					</Box>
				</Box>

				{/* Question 7 */}
				<Box pt="20px">
					<Heading variant="blogQuestion" pb="20px" pt="30px">
						7. With India’s startup ecosystem booming, how do you view the
						challenges and opportunities for venture capital firms like Artha
						Venture Fund?
					</Heading>
					<Box>
						<Text variant="blogAnswer" pb="16px">
							One of the significant challenges we face is the pressure to
							expand our fund size due to India’s immense potential. There’s a
							strong push, both domestically and internationally, to adopt
							Western investment models that involve injecting large amounts of
							capital into startups at very early stages. However, in the Indian
							context, this approach doesn’t always yield the desired results.
							<br /> <br />
							India is a unique market with its own dynamics. Our economy
							remains relatively labor-intensive, with lower labor costs than
							many other countries. We believe that staying small and operating
							as a micro-VC allows us to better serve the needs of Indian
							startups and consumers. We are committed to focusing on
							early-stage ventures without intending to launch larger funds that
							would require prematurely writing bigger checks.
							<br /> <br />
							The challenge arises because many investors, especially LPs, often
							advocate for scaling up and applying investment strategies that
							have worked in the U.S. or other Western markets. However, we’ve
							observed through multiple market cycles that simply pumping large
							sums of money into startups early on doesn’t translate effectively
							in India. The Indian consumer is highly discerning and
							value-conscious, not easily swayed by free offerings or aggressive
							marketing tactics. They seek long-term value and are loyal to
							products and services that meet their needs.
							<br /> <br />
							When startups receive excessive funding too soon, they may engage
							in practices that undermine their long-term sustainability, such
							as overspending on customer acquisition without solidifying their
							core value proposition. This can be detrimental not only to the
							ventures themselves but also to the ecosystem&apos;s overall
							health.
							<br /> <br />
							On the other hand, companies like
							<span style={{ fontWeight: "bold" }}>Everest Fleet</span> and
							<span style={{ fontWeight: "bold" }}>LenDenClub </span> exemplify
							how focusing on solving real problems and addressing genuine
							consumer needs can lead to substantial profit potential. These
							ventures, which might not fit the traditional mold of tech
							startups or typical VC investments, have demonstrated that it’s
							possible to scale revenues significantly—growing 100% year over
							year—while remaining profitable.
							<br /> <br />
							The opportunity for venture capital firms like Artha Venture Fund
							lies in embracing and defining the Indian way of entrepreneurship.
							By resisting the urge to conform to Western investment models and
							instead tailoring our approach to the unique characteristics of
							the Indian market, we can support startups that are built for
							long-term success.
						</Text>
					</Box>
				</Box>

				{/* Question 8 */}
				<Box pt="20px">
					<Heading variant="blogQuestion" pb="20px" pt="30px">
						8. How does Artha Venture Fund engage with Indian institutional and
						domestic investors to strengthen the capital base for startups?
					</Heading>
					<Box>
						<Text variant="blogAnswer" pb="16px">
							At Artha Venture Fund, we emphasize building strong relationships
							with our investors, particularly Indian institutional and domestic
							investors. We are grateful to have had
							<span style={{ fontWeight: "bold" }}>SIDBI</span> as one of our
							early institutional backers. Additionally, we have been fortunate
							to receive support from esteemed family offices such as
							<span style={{ fontWeight: "bold" }}>
								DSP, Snow Leopard, Thermax, Glance Finance, Morde, Sat Group,
								Wallfort,
							</span>
							and several other prominent families who share our vision of
							empowering Indian entrepreneurs.
							<br /> <br />
							As a family office-first fund, we prioritize open and transparent
							communication with our investors. We host at least two Artha
							Unplugged events every quarter, where we connect our portfolio
							founders with family offices. These gatherings have provided our
							founders with opportunities to expand their networks and sales
							funnels by engaging directly with enthusiastic family office
							investors. This direct interaction often leads to valuable
							collaborations and business development opportunities for our
							startups.
							<br /> <br />
							We also communicate regularly through our newsletter,
							<span style={{ fontWeight: "bold" }}>FUNDamentals</span>, and
							quarterly updates, ensuring our investors are well-informed about
							our activities and progress. Personally, I have standing meetings
							with many of our LPs, often over morning coffee once a month.
							These conversations are invaluable—they strengthen our
							relationships and lead to new investment ideas and insights into
							market trends. Moreover, several of our family office LPs actively
							co-evaluate potential ventures with us, bringing their expertise
							and perspectives into our investment process.
							<br /> <br />
							While our focus is on early-stage, though microVC funds may
							sometimes make us perceived as “not big enough” by certain
							institutional investors, our network of family offices has
							consistently supported us. These investors have written some of
							our largest checks and have been integral to our strategies and
							success.
						</Text>
					</Box>
				</Box>

				{/* Question 9 */}
				<Box pt="20px">
					<Heading variant="blogQuestion" pb="20px" pt="30px">
						9. What are Artha Venture Fund’s long-term goals and vision for the
						future? How do you see the VC landscape in India shaping up over the
						next 5-10 years?
					</Heading>
					<Box>
						<Text variant="blogAnswer" pb="16px">
							At Artha Venture Fund, our long-term vision is to empower Indian
							founders throughout their entrepreneurial journey, providing them
							with the capital and support needed to scale from inception to
							significant growth stages. Through our three funds—
							<span style={{ fontWeight: "bold", marginRight: "4px" }}>
								Artha Venture Fund, Artha Select Fund, and Artha Continuum
								Fund—managed
							</span>
							by
							<span style={{ fontWeight: "bold", marginLeft: "4px" }}>
								Artha Venture Partners
							</span>
							, we aim to offer startups access to equity investments totaling
							up to <span style={{ fontWeight: "bold" }}>INR 100 crores</span>.
							In addition to equity financing, we leverage our LPs and family
							offices network to provide structured finance solutions, enabling
							ventures to progress from zero to one hundred—not just zero to
							one.
							<br /> <br />
							We are proud to be India’s first microVC fund house with a 0-100
							approach. Our strategy involves launching nimble, focused microVC
							funds that can swiftly adapt to each stage of a venture’s growth.
							Over the next <span style={{ fontWeight: "bold" }}>10 years</span>
							, we plan to expand our portfolio from{" "}
							<span style={{ fontWeight: "bold" }}>
								125 to at least 250 to 300 ventures
							</span>
							, with an ambitious goal of backing over{" "}
							<span style={{ fontWeight: "bold" }}>1,000 Indian startups</span>.
						</Text>
					</Box>
				</Box>
			</Box>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				The content in this section is curated by Team IVCA. For any feedback,
				connect with&nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default FundInFocusArthaVenture;
